import { render } from "./BooksComponent.vue?vue&type=template&id=f24b4be8&scoped=true"
import script from "./BooksComponent.vue?vue&type=script&lang=js"
export * from "./BooksComponent.vue?vue&type=script&lang=js"

import "./BooksComponent.vue?vue&type=style&index=0&id=f24b4be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24b4be8"]])

export default __exports__